import React, { useLayoutEffect, useRef, useState } from "react"
import styled from "@emotion/styled"
import { useWatchVariations, mvSubscribe } from "./../../model/model-variations/context"
import { useNavigation } from "contexts/Navigation"

const Main = styled.a`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  overflow: hidden;
  z-index: 1;
  visibility: hidden;
  text-decoration: none;
  &.wv_reveal {
    visibility: visible;
  }

  &.focus-visible {
    outline-offset: -3px !important;
  }
`

export function CardLink({ ctx }) {
  const { route, active, wactive, getModel } = useWatchVariations(ctx)
  const [wprops, setWprops] = useState(null)
  const rfmain = useRef()
  const navigation = useNavigation()

  function display(v) {
    rfmain.current?.classList[!v ? "add" : "remove"]("wv_reveal")
  }

  function onRoute(v) {
    display(!!v)
  }

  function onWactive(v) {
    if (!v) return
    setWprops({
      href: v.specs[8],
      label: `${v.family} - ${v.specs[0]}`,
    })
  }

  function onClick(e) {
    e.preventDefault()
    navigation.navigate(e.currentTarget.getAttribute("href"))
  }

  useLayoutEffect(() => mvSubscribe("CardLink route", route, onRoute), [])
  useLayoutEffect(() => mvSubscribe("CardLink wactive", wactive, onWactive), [])

  return wprops ? (
    <Main ref={rfmain} className={!route.get() ? "wv_reveal" : ""} onClick={onClick} href={navigation.localize(wprops.href)} aria-label={wprops.label}></Main>
  ) : null
}
